import React from 'react';

import type { ImageAsset } from '../../../../../core/data-sources/content-components/types.js';

import { LinkWithPulse } from '../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import Image from '../../teasers/teaserComponents/Image.js';

export interface LinkInternalProps {
  id: string;
  slug: string;
  title: string;
  image?: ImageAsset;
}

const LinkInternal: React.FC<LinkInternalProps> = ({
  id,
  title,
  slug,
  image,
}) => {
  return (
    <LinkWithPulse
      className="internal-link"
      href={`/artikkel/${id}/${slug}`}
      objectId="internal-link"
      name="link to internal article"
    >
      <span className="internal-link-header">Sjekk også</span>
      <div className="info-wrapper">
        <p className="internal-link-title">{title}</p>
        {image && (
          <Image imageAsset={image} title={title} width={180} height={180} />
        )}
      </div>
    </LinkWithPulse>
  );
};

export default LinkInternal;
